export enum PromotionTypeEnum {
  CODE = 'CODE',
  DISCOUNT = 'DISCOUNT',
  CHALLENGE = 'CHALLENGE',
}
